module.exports = __webpack_public_path__ + "img/therr-point.2ef58de7.svg";